/** @format */

import { useCallback, type ReactNode, type MouseEvent } from 'react';
import useGa4Analytics from 'src/hooks/useGa4Analytics';
import {
  resolveWidgetGa4Category,
  resolveWidgetGa4Name,
  resolveWidgetGa4Position,
  type WidgetGa4Data
} from 'src/analytics/widgetGa4';
import type { Widget } from 'src/types/widget';

const INTERACTIVE_SELECTOR =
  'a[href], button:not(:disabled), [role="button"], input[type="submit"], input[type="button"]';

type WidgetGa4ClickTrackerProps = {
  data?: Widget;
  children?: ReactNode;
};

export function WidgetGa4ClickTracker({ data, children }: WidgetGa4ClickTrackerProps) {
  const { trackWidgetClick } = useGa4Analytics();

  const handleClick = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      const interactive = (event.target as Element).closest(INTERACTIVE_SELECTOR);
      if (!interactive) {
        return;
      }

      const ga4Data = data as WidgetGa4Data | undefined;
      trackWidgetClick({
        widget_name: resolveWidgetGa4Name(ga4Data),
        widget_position: resolveWidgetGa4Position(ga4Data),
        widget_category: resolveWidgetGa4Category(ga4Data)
      });
    },
    [data, trackWidgetClick]
  );

  return (
    <div className="widget-ga4-tracker" onClick={handleClick}>
      {children}
    </div>
  );
}
